export const writeableSolutionFormDefaults = {
  "solution-name": "",
  "solution-vbc-website-display-name": "",
  "solution-developer": "",
  "solution-short-description": "",
  "country-select": null,
  "solution-development-stage": [],
  "solution-assessment-methodology": null,
  "solution-intervention-type": null,
  "solution-asset-type": "",
  "solution-is-ready-for-sale": false,
  "solution-start-date": null,
  "solution-end-date": null,
  "solution-is-carbon-offset": false,
  latitude: "",
  longitude: "",
  "solution-sdg": [],
  interventions: [],
  outcomes: [
    {
      unit: "",
      value: "",
      "unit-of-sale": false,
      "outcome-start-date": null,
      "outcome-end-date": null,
      outcomeCounter: 1,
      origin: "draft" as const,
    },
  ],
  "programme-info": {
    "carbon-crediting-programme": [],
    "carbon-accounting-methodology": "",
    "description-document": "",
    "asset-type": null,
  },
  "internal-details": {
    "website-url": "",
    "xero-account-number": "",
    "research-team-notes": "",
    "additional-resources-link": "",
  },
  "risk-monitoring": {
    "is-risk-alert-enabled": false,
    "buffer-value-km": 10,
    "geospatial-file": null,
  },
};
